export default function (prop) {
    return `mdc-theme--${prop}-bg`;
}
//# sourceMappingURL=generateThemeClass.js.map